import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Recipe } from '@/types/api-models';

export type StoreStatus = 'idle' | 'loading' | 'loaded' | 'error';

interface RecipeStore {
  recipes: Recipe[];
  status: StoreStatus;
  setRecipes: (recipes: Recipe[]) => void;
  setStatus: (status: StoreStatus) => void;
  upsert: (recipe: Recipe) => void;
  remove: (id: string) => void;
  clear: () => void;
}

export const useRecipeStore = create<RecipeStore>()(
  persist(
    (set) => ({
      recipes: [],
      status: 'idle' as StoreStatus,

      setRecipes: (recipes) => set({ recipes }),

      setStatus: (status) => set({ status }),

      upsert: (recipe) =>
        set((state) => {
          const idx = state.recipes.findIndex((r) => r.id === recipe.id);
          return {
            recipes:
              idx >= 0
                ? state.recipes.map((r) => (r.id === recipe.id ? recipe : r))
                : [recipe, ...state.recipes],
          };
        }),

      remove: (id) =>
        set((state) => ({ recipes: state.recipes.filter((r) => r.id !== id) })),

      clear: () => set({ recipes: [], status: 'idle' }),
    }),
    {
      name: 'bp-recipes',
      // Persist only the recipe data, not loading state — status resets to
      // 'idle' on rehydration and the digest check decides when to refetch.
      partialize: (state) => ({ recipes: state.recipes }),
    }
  )
);
